const t = {
  content: "",
  group: "block",
  marks: "",
  atom: !0,
  attrs: {
    type: { default: "twitterFollowButton" },
    username: { default: "" }
  },
  toDOM() {
    return ["div"];
  }
};
export {
  t as twitterFollowButtonSpec
};
